"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[11991],{

/***/ 82495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Chart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/features/company/constants.ts
var constants = __webpack_require__(55564);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/features/company/Chart/styled.ts
var styled = __webpack_require__(33263);
// EXTERNAL MODULE: ./src/features/company/Chart/ExpandButtonToggle.tsx
var ExpandButtonToggle = __webpack_require__(68068);
;// CONCATENATED MODULE: ./src/features/company/Chart/ChartDetail.tsx










function ChartDetail(param) {
    var stateTimeframe = param.timeframe, showTimeframes = param.showTimeframes, _company = param.company, company = _company === void 0 ? {} : _company, chart = param.chart, onSelectTimeframe = param.onSelectTimeframe, onExpand = param.onExpand;
    var _time = company.time, time = _time === void 0 ? "" : _time, companyChange = company.change, companyPercentage = company.percentage, price = company.price, volume = company.volume, average = company.average;
    var ref;
    var timeframe = (ref = chart === null || chart === void 0 ? void 0 : chart.timeframe) !== null && ref !== void 0 ? ref : stateTimeframe;
    var isTimeframeToday = timeframe === "today";
    var change = isTimeframeToday ? companyChange : chart === null || chart === void 0 ? void 0 : chart.change;
    var percentage = isTimeframeToday ? companyPercentage : chart === null || chart === void 0 ? void 0 : chart.percentage;
    var renderTime = (0,react.useCallback)(function() {
        if (timeframe === "today") {
            var timeOnly = time.slice(4);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Today ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                        dateTime: "".concat(timeOnly, "+07:00"),
                        children: "".concat(time, " WIB")
                    })
                ]
            });
        }
        if (timeframe === "ytd") {
            return "Year to Date";
        }
        if (timeframe[1] === "w") {
            return "Past ".concat(timeframe[0], " Week");
        }
        if (timeframe[1] === "m") {
            return "Past ".concat(timeframe[0], " Month");
        }
        if (timeframe[1] === "y") {
            return "Past ".concat(timeframe[0], " Year");
        }
        return "";
    }, [
        timeframe,
        time
    ]);
    var numeralChange = (0,react.useMemo)(function() {
        return numeral_default()(change);
    }, [
        change
    ]);
    var priceType = (0,react.useMemo)(function() {
        if (numeralChange.value() > 0) return "up";
        if (numeralChange.value() < 0) return "down";
        return "netral";
    }, [
        numeralChange
    ]);
    var formattedPrice = (0,react.useMemo)(function() {
        return numeral_default()(price).format("0,0.[00]");
    }, [
        price
    ]);
    var formattedChange = (0,react.useMemo)(function() {
        var val = numeralChange.value();
        if (Number.isNaN(val)) return "NA";
        if (val === 0) return "0.00";
        return numeralChange.format("+0,0.[00]");
    }, [
        numeralChange
    ]);
    var formattedPercentage = (0,react.useMemo)(function() {
        return numeral_default()(percentage || 0).format("0.00");
    }, [
        percentage
    ]);
    var formattedVolume = (0,react.useMemo)(function() {
        return Number.isNaN(volume) ? "NA" : (0,general/* parseCountAbbrv2 */.St)(volume);
    }, [
        volume
    ]);
    var formattedAvgVolume = (0,react.useMemo)(function() {
        return Number.isNaN(Number(average)) ? "NA" : (0,general/* parseCountAbbrv2 */.St)(parseInt(String(average), 10));
    }, [
        average
    ]);
    var isNAorZero = (0,react.useMemo)(function() {
        return [
            "NA",
            "0",
            "0.00"
        ].includes(String(formattedAvgVolume));
    }, [
        formattedAvgVolume
    ]);
    var renderPriceTime = function() {
        var ref, ref1, ref2, ref3, ref4;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ResponsiveText */.lz, {
                            as: "h3",
                            family: "bold",
                            margin: "0px",
                            padding: "0px",
                            children: formattedPrice
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CustomIconmoon */.mJ, {
                            as: "span",
                            className: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref = constants/* priceChange */.lt[priceType]) === null || ref === void 0 ? void 0 : ref.icon,
                            color: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref1 = constants/* priceChange */.lt[priceType]) === null || ref1 === void 0 ? void 0 : ref1.color,
                            hoverColor: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref2 = constants/* priceChange */.lt[priceType]) === null || ref2 === void 0 ? void 0 : ref2.color
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ResponsiveText */.lz, {
                            as: "h3",
                            color: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref3 = constants/* priceChange */.lt[priceType]) === null || ref3 === void 0 ? void 0 : ref3.color,
                            px: "5px",
                            children: formattedChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ResponsiveText */.lz, {
                            as: "h3",
                            color: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref4 = constants/* priceChange */.lt[priceType]) === null || ref4 === void 0 ? void 0 : ref4.color,
                            children: "(".concat(formattedPercentage, "%)")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TimeText */.LC, {
                    as: "span",
                    color: color/* default.midgray */.Z.midgray,
                    size: "12px",
                    pt: "3px",
                    children: renderTime()
                })
            ]
        });
    };
    var renderVolume = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ChartSectionItem */.nJ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "h3",
                    size: "16px",
                    children: formattedVolume
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: color/* default.midgray */.Z.midgray,
                    size: "12px",
                    pt: "3px",
                    children: "Volume"
                })
            ]
        });
    };
    var renderAvgVolume = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ChartSectionItem */.nJ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "h3",
                    size: "16px",
                    children: formattedAvgVolume
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: color/* default.midgray */.Z.midgray,
                    size: "12px",
                    pt: "3px",
                    children: "Avg volume"
                })
            ]
        });
    };
    var renderTimeframeButtonsMobile = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TimeframeButtonsMobile */.yX, {
            showTimeframes: showTimeframes,
            timeframe: timeframe,
            onSelectTimeframe: onSelectTimeframe,
            timeFrameList: constants/* chartTimeframes */.Iv
        });
    };
    var renderExpandButtonToggle = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandButtonToggle/* default */.Z, {
            onExpand: onExpand
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    renderPriceTime(),
                    renderVolume(),
                    !isNAorZero && renderAvgVolume()
                ]
            }),
            renderTimeframeButtonsMobile(),
            renderExpandButtonToggle()
        ]
    });
}
/* harmony default export */ var Chart_ChartDetail = (ChartDetail);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(508);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/features/company/Chart/CompanyChart.tsx








var fillColor = color/* default.clearDay */.Z.clearDay;
var lineColor = color/* default.mountainMeadow */.Z.mountainMeadow;
function CompanyChart(param) {
    var chart = param.chart, companyType = param.companyType, onClickChart = param.onClickChart;
    var ref = chart !== null && chart !== void 0 ? chart : {}, tmp = ref.prices, chartPrices = tmp === void 0 ? [] : tmp, tmp1 = ref.previous_timeframe_price, previousPrices = tmp1 === void 0 ? null : tmp1, timeframe = ref.timeframe, _previous = ref.previous, previous = _previous === void 0 ? 0 : _previous;
    var isRdn = (companyType === null || companyType === void 0 ? void 0 : companyType.toLowerCase()) === "reksadana";
    var isSelectedTimeframe = [
        "ytd",
        "1w"
    ].includes(timeframe);
    var prices = (0,react.useMemo)(function() {
        if (isSelectedTimeframe && previousPrices && !isRdn && companyType) {
            // case delisting stock and no prices available
            if (chartPrices.length === 0 && !previousPrices.value && previous) {
                var previousPrice = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousPrices), {
                    value: previous.toString(),
                    date: "0"
                });
                return [
                    previousPrice,
                    previousPrice
                ];
            }
            if (previousPrices.value) {
                return [
                    previousPrices
                ].concat((0,_to_consumable_array/* default */.Z)(chartPrices));
            }
            return chartPrices;
        }
        return chartPrices;
    }, [
        chartPrices,
        previousPrices,
        timeframe,
        isRdn
    ]);
    var createPreviousMonth = function(numberOfMonth) {
        var data = [];
        var dateStart = moment_default()().subtract(numberOfMonth, "month");
        var dateEnd = moment_default()();
        while(dateStart.diff(dateEnd, "months") <= 0){
            data.push(dateStart.format("MMM YYYY"));
            dateStart.add(1, "month");
        }
        return data;
    };
    var createPreviousYear = function(numberOfYear) {
        var data = [];
        var dateStart = moment_default()().subtract(numberOfYear, "y");
        var dateEnd = moment_default()();
        while(dateStart.diff(dateEnd, "years") <= 0){
            data.push(dateStart.format("YYYY"));
            dateStart.add(1, "year");
        }
        return data;
    };
    var ref1 = (0,react.useMemo)(function() {
        if (timeframe === "1w") return [
            "DD MMM",
            5,
            []
        ];
        if (timeframe === "1m") return [
            "DD MMM",
            5,
            []
        ];
        if (timeframe === "3m") {
            var previousMonths = createPreviousMonth(2);
            return [
                "MMM",
                3,
                previousMonths
            ];
        }
        if (timeframe === "ytd") return [
            "DD MMM",
            5
        ];
        if (timeframe === "1y") {
            var previousMonths1 = createPreviousMonth(11);
            return [
                "MMM",
                12,
                previousMonths1,
                false
            ];
        }
        if (timeframe === "3y") {
            var previousYear = createPreviousYear(2);
            return [
                "YYYY",
                3,
                previousYear
            ];
        }
        if (timeframe === "5y") {
            var previousYear1 = createPreviousYear(4);
            return [
                "YYYY",
                5,
                previousYear1
            ];
        }
        return [
            "HH:mm",
            6,
            []
        ];
    }, [
        timeframe
    ]), format = ref1[0], maxTicks = ref1[1], labels = ref1[2], tmp2 = ref1[3], autoSkip = tmp2 === void 0 ? true : tmp2;
    var tempLabels = [];
    var chartData = (0,react.useMemo)(function() {
        return {
            labels: prices.map(function(price, index) {
                if (!price.formatted_date && price.date === "0") return "";
                if (isSelectedTimeframe && (previousPrices === null || previousPrices === void 0 ? void 0 : previousPrices.value) && index === 0 && !isRdn) {
                    return "";
                }
                var formattedDate = moment_default()(price.formatted_date);
                var monthYear = formattedDate.format("MMM YYYY");
                var month = formattedDate.format("MMM");
                var year = formattedDate.format("YYYY");
                var formattedByTimeframe = formattedDate.format(format);
                switch(timeframe){
                    case "1w":
                        if (formattedDate.hour() <= 9 && !tempLabels.includes(formattedByTimeframe)) {
                            tempLabels.push(formattedByTimeframe);
                            return formattedByTimeframe;
                        }
                        return "";
                    case "1m":
                    case "today":
                        return formattedDate.minute() === 0 ? formattedByTimeframe : "";
                    case "3m":
                    case "1y":
                        if (labels.includes(monthYear)) {
                            labels.splice(labels.indexOf(monthYear), 1);
                            return month;
                        }
                        return "";
                    case "3y":
                    case "5y":
                        if (labels.includes(year)) {
                            labels.splice(labels.indexOf(year), 1);
                            return year;
                        }
                        return "";
                    case "ytd":
                        return formattedByTimeframe;
                    default:
                        return moment_default()(price.formatted_date).format(format);
                }
            }),
            datasets: [
                {
                    fill: true,
                    tension: 0,
                    backgroundColor: fillColor,
                    borderColor: lineColor,
                    borderCapStyle: "butt",
                    borderDashOffset: 0.0,
                    borderDash: [],
                    borderJoinStyle: "round",
                    borderWidth: 2,
                    data: prices.map(function(pr) {
                        return parseInt(pr.value, 10);
                    })
                }, 
            ]
        };
    }, [
        prices,
        format,
        isRdn
    ]);
    var options = (0,react.useMemo)(function() {
        return {
            animation: {
                duration: 0
            },
            resizeDelay: 0,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: false
                }
            },
            maintainAspectRatio: false,
            scales: {
                y: {
                    position: "right",
                    grid: {
                        display: false,
                        drawBorder: false
                    },
                    ticks: {
                        maxTicksLimit: 8,
                        callback: function callback(val) {
                            var price = val;
                            // if price contain decimal, then hide tick
                            if (typeof price === "number" && price % 1 !== 0) price = null;
                            return price || null;
                        }
                    }
                },
                x: {
                    grid: {
                        display: false
                    },
                    ticks: {
                        align: "start",
                        maxTicksLimit: maxTicks,
                        maxRotation: 0,
                        callback: function callback(val) {
                            // eslint-disable-next-line react/no-this-in-sfc
                            return this.getLabelForValue(val) || null;
                        },
                        autoSkip: autoSkip,
                        precision: 0
                    }
                }
            },
            elements: {
                point: {
                    radius: 0
                }
            },
            events: [
                "click"
            ],
            onClick: onClickChart
        };
    }, [
        maxTicks,
        onClickChart
    ]);
    var finalChartData = (0,react.useMemo)(function() {
        if (prices.length === 0) {
            return {
                datasets: [
                    {
                        data: [
                            previous,
                            previous
                        ],
                        borderColor: "#E5E5E5",
                        borderDash: [
                            4,
                            4
                        ],
                        borderWidth: 1,
                        fill: false
                    }, 
                ],
                labels: [
                    "",
                    ""
                ]
            };
        }
        return chartData;
    }, [
        chartData,
        previous,
        prices,
        timeframe
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Line */.x1, {
        data: finalChartData,
        options: options,
        height: 300
    });
}
/* harmony default export */ var Chart_CompanyChart = (CompanyChart);

// EXTERNAL MODULE: ./src/features/company/Chart/EmptyChart.tsx + 1 modules
var EmptyChart = __webpack_require__(19970);
;// CONCATENATED MODULE: ./src/features/company/Chart/MainChart.tsx






function MainChart(param) {
    var visible = param.visible, symbol = param.symbol, timeframe = param.timeframe, showTimeframes = param.showTimeframes, onSelectTimeframe = param.onSelectTimeframe, isLoadingChart = param.isLoadingChart, chart = param.chart, onClickChart = param.onClickChart, disableChartbitLink = param.disableChartbitLink, companyType = param.companyType;
    return !visible ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* MainChartWrapper */.yd, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TimeframeButtonsDesktop */.Kw, {
                showTimeframes: showTimeframes,
                timeframe: timeframe,
                onSelectTimeframe: onSelectTimeframe,
                timeFrameList: constants/* chartTimeframes */.Iv
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* MainChartContent */.LH, {
                children: [
                    chart && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ChartContainer */.BO, {
                        children: disableChartbitLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_CompanyChart, {
                            chart: chart,
                            companyType: companyType,
                            onClickChart: onClickChart
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/symbol/".concat(symbol, "/chartbit"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                rel: "noopener noreferrer",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_CompanyChart, {
                                    chart: chart,
                                    companyType: companyType,
                                    onClickChart: onClickChart
                                })
                            })
                        })
                    }),
                    !isLoadingChart && !chart && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyChart/* default */.Z, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var Chart_MainChart = (MainChart);

;// CONCATENATED MODULE: ./src/features/company/Chart/index.tsx





function ChartV2(param) {
    var _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, company = param.company, isLoadingChart = param.isLoadingChart, chart = param.chart, timeframe = param.timeframe, isChartVisible = param.isChartVisible, onSelectTimeFrame = param.onSelectTimeFrame, onExpand = param.onExpand, onClickChart = param.onClickChart, disableChartbitLink = param.disableChartbitLink;
    var showDetail = (0,react.useMemo)(function() {
        var ref;
        var whitelistSectors = [
            "index asing",
            "commodities",
            "fx",
            "crypto",
            "index",
            "reksadana",
            "waran",
            "etf",
            "right", 
        ];
        // Pass if sector is whitelisted
        if (whitelistSectors.includes(company === null || company === void 0 ? void 0 : (ref = company.type_company) === null || ref === void 0 ? void 0 : ref.toLowerCase())) {
            return true;
        }
        return !!chart;
    }, [
        chart,
        company
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ChartWrapper */.hC, {
        as: "section",
        children: [
            showDetail && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_ChartDetail, {
                timeframe: timeframe,
                showTimeframes: isChartVisible,
                symbol: symbol,
                onExpand: onExpand,
                company: company,
                chart: chart,
                onSelectTimeframe: onSelectTimeFrame
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_MainChart, {
                timeframe: timeframe,
                showTimeframes: showDetail,
                symbol: symbol,
                onSelectTimeframe: onSelectTimeFrame,
                visible: isChartVisible,
                isLoadingChart: isLoadingChart,
                chart: chart,
                onClickChart: onClickChart,
                disableChartbitLink: disableChartbitLink,
                companyType: company === null || company === void 0 ? void 0 : company.type_company
            })
        ]
    });
}
/* harmony default export */ var Chart = (ChartV2);


/***/ }),

/***/ 11991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ features_company; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/company.ts + 1 modules
var company = __webpack_require__(74645);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useProtectedRoute.js
var useProtectedRoute = __webpack_require__(56198);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/lib/entities/fundachart.ts
var fundachart = __webpack_require__(4822);
// EXTERNAL MODULE: ./src/lib/entities/comparison.ts + 1 modules
var comparison = __webpack_require__(60913);
// EXTERNAL MODULE: ./src/features/company/slice.ts
var slice = __webpack_require__(90636);
// EXTERNAL MODULE: ./src/features/paywall/store/index.ts + 1 modules
var store = __webpack_require__(92182);
// EXTERNAL MODULE: ./src/features/paywall/constants.ts
var constants = __webpack_require__(11298);
// EXTERNAL MODULE: ./src/features/paywall/types.ts
var types = __webpack_require__(5072);
;// CONCATENATED MODULE: ./src/features/paywall/store/useErrorPaywall.ts








var ERROR = 402;
function useErrorPaywall(activeTab, symbol) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var error = (0,es/* useSelector */.v9)(fundachart/* selectors */.wl).error;
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), companyError = ref.error;
    var ref1 = (0,es/* useSelector */.v9)(comparison/* selectors */.wl), comparisonError = ref1.error;
    var resetProStatus = (0,store/* default */.Z)(function(state) {
        return state.resetProStatus;
    });
    (0,react.useEffect)(function() {
        if (!activeTab || !symbol) return;
        var TAB = activeTab.toUpperCase();
        switch(TAB){
            case constants/* CompanyWidgetEnum.FUNDACHART */.Uw.FUNDACHART:
                checkIsError(error);
                break;
            case constants/* CompanyWidgetEnum.SEASONALITY */.Uw.SEASONALITY:
            case constants/* CompanyWidgetEnum.FINANCIALS */.Uw.FINANCIALS:
                checkIsError(companyError);
                dispatch(slice/* default.actions.resetErrorState */.ZP.actions.resetErrorState());
                break;
            case constants/* CompanyWidgetEnum.COMPARISON */.Uw.COMPARISON:
                checkIsError(comparisonError);
                break;
            default:
                break;
        }
    }, [
        error,
        companyError,
        comparisonError,
        activeTab,
        symbol
    ]);
    var checkIsError = function(error) {
        var ref;
        if (!error) return false;
        var isError = ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === ERROR;
        if (isError) {
            resetProStatus(types/* SectionEnum.company */.P.company);
        }
        return true;
    };
    return {
        error: error,
        companyError: companyError,
        comparisonError: comparisonError
    };
}
/* harmony default export */ var store_useErrorPaywall = (useErrorPaywall);

;// CONCATENATED MODULE: ./src/features/paywall/store/useCompany.ts






function useCompany(activeTab, symbol) {
    var ref = (0,store/* default */.Z)(function(state) {
        return {
            getStatus: state.getStatus,
            addCounter: state.addCounter
        };
    }, shallow/* default */.Z), getStatus = ref.getStatus, addCounter = ref.addCounter;
    store_useErrorPaywall(activeTab, symbol);
    var getFeatureByKey = function(key) {
        var KEY = key.toUpperCase();
        return constants/* PaywallFeatureEnum */.qU[KEY];
    };
    var companyGetStatus = function(key) {
        var feature = getFeatureByKey(key);
        if (!feature) return;
        getStatus({
            key: types/* SectionEnum.company */.P.company,
            feature: feature,
            company: symbol
        });
        addCounter({
            feature: feature,
            company: symbol
        });
    };
    var companyAddCounter = function(key) {
        var feature = getFeatureByKey(key);
        if (!feature) return;
        addCounter({
            feature: feature,
            company: symbol
        });
    };
    var getWidgetStatus = function() {
        var features = [
            constants/* PaywallFeatureEnum.ORDERBOOK */.qU.ORDERBOOK,
            constants/* PaywallFeatureEnum.RUNNING_TRADE */.qU.RUNNING_TRADE
        ];
        getStatus({
            key: types/* SectionEnum.company */.P.company,
            feature: features,
            company: symbol
        });
        // add counter for orderbook and running trade stream widget
        constants/* CompanyStreamWidget.forEach */.LB.forEach(function(key) {
            return companyAddCounter(key);
        });
    };
    (0,react.useEffect)(function() {
        if (!symbol) return;
        // undefined means the current tab is the stream tab
        if (activeTab === undefined) {
            getWidgetStatus();
            return;
        }
        if (!activeTab) return;
        companyGetStatus(activeTab);
    }, [
        activeTab,
        symbol
    ]);
    return {
        addCounter: function(key) {
            return companyAddCounter(key);
        }
    };
}
/* harmony default export */ var store_useCompany = (useCompany);

// EXTERNAL MODULE: ./src/global/Loading/PageLoader.jsx + 2 modules
var PageLoader = __webpack_require__(598);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./src/constants/clevertap.js
var constants_clevertap = __webpack_require__(92124);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/global/QueryProvider/index.tsx
var QueryProvider = __webpack_require__(62780);
// EXTERNAL MODULE: ./@types/company.d.ts
var company_d = __webpack_require__(82964);
// EXTERNAL MODULE: ./src/features/company/Navbar/index.tsx + 2 modules
var Navbar = __webpack_require__(82603);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/utils/company.ts
var utils_company = __webpack_require__(4168);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
// EXTERNAL MODULE: ./src/global/Notation/IndicatorBar.tsx
var IndicatorBar = __webpack_require__(52491);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionBar.tsx
var CorpActionBar = __webpack_require__(88679);
// EXTERNAL MODULE: ./src/utils/tags.tsx + 2 modules
var tags = __webpack_require__(91601);
// EXTERNAL MODULE: ./src/global/Moderation/Modals/index.jsx + 7 modules
var Modals = __webpack_require__(31359);
// EXTERNAL MODULE: ./src/features/company/constants.ts
var company_constants = __webpack_require__(55564);
// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts + 1 modules
var useIsUserSyariah = __webpack_require__(66940);
// EXTERNAL MODULE: ./src/global/Notation/PopoverNotation.tsx
var PopoverNotation = __webpack_require__(63631);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/features/company/Header/styled.ts
var styled = __webpack_require__(50489);
// EXTERNAL MODULE: ./src/features/company/Header/FollowCompanyButton.tsx
var FollowCompanyButton = __webpack_require__(89238);
;// CONCATENATED MODULE: ./src/features/company/Header/index.tsx























var cleanSymbol = utils_company/* default.cleanSymbol */.Z.cleanSymbol, isReksaDana = utils_company/* default.isReksaDana */.Z.isReksaDana;
var STATUS_LIST = {
    SUSPENDED: "STATUS_SUSPENDED",
    DELISTED: "STATUS_DELISTED"
};
function Header(param) {
    var _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, company = param.company, _isGuestCompany = param.isGuestCompany, isGuestCompany = _isGuestCompany === void 0 ? false : _isGuestCompany, onClickLink = param.onClickLink, onClickFollow = param.onClickFollow, onClickCorpAction = param.onClickCorpAction, onClickNotation = param.onClickNotation, onClickBuyButton = param.onClickBuyButton, onExpandToggle = param.onExpandToggle;
    var ref;
    var name = company.name, sector = company.sector, followers = company.followers, followed = company.followed, icon_url = company.icon_url, _country = company.country, country = _country === void 0 ? "ID" : _country, _notation = company.notation, notation = _notation === void 0 ? [] : _notation, uma = company.uma, _corp_action = company.corp_action, corp_action = _corp_action === void 0 ? {} : _corp_action, status = company.status, _catalogs = company.catalogs, catalogs = _catalogs === void 0 ? [] : _catalogs, exchange = company.exchange, _type_company = company.type_company, type_company = _type_company === void 0 ? "" : _type_company, id = company.id, tradeable = company.tradeable, dayTradeInfo = company.day_trade_info;
    var ref1 = dayTradeInfo || {}, multiplier = ref1.multiplier, isShowMultiplier = ref1.is_show_multiplier;
    var ref2 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref2.data;
    var tmp = profileData.country, profileCountry = tmp === void 0 ? "ID" : tmp;
    var ref3 = (0,react.useState)(!!icon_url), isIconAvailable = ref3[0], setIsIconAvailable = ref3[1];
    var ref4 = (0,react.useState)(false), isFollowerVisible = ref4[0], setIsFollowerVisible = ref4[1];
    var ref5 = (0,react.useState)(false), isFollowCompanyVisible = ref5[0], setIsFollowCompanyVisible = ref5[1];
    var ref6 = (0,react.useState)(!!followed), isFollowing = ref6[0], setIsFollowing = ref6[1];
    var isNotationAvailable = !!notation.length;
    var isCorpActionAvailable = corp_action === null || corp_action === void 0 ? void 0 : corp_action.active;
    var isSuspended = status === STATUS_LIST.SUSPENDED;
    var isDelisted = status === STATUS_LIST.DELISTED;
    var isCompanyStock = true;
    var isTradeable = tradeable === 1;
    var POPUP_COUNTRY_FLAG_TEXT = "This stock is traded on ".concat(exchange, " exchange");
    var buttonBuyRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var isUserSyariah = (0,useIsUserSyariah/* default */.Z)();
    var showMultiplier = (0,react.useMemo)(function() {
        return [
            parseInt(multiplier, 10) > 1,
            isShowMultiplier,
            !isUserSyariah
        ].every(Boolean);
    }, [
        multiplier,
        isShowMultiplier,
        isUserSyariah
    ]);
    // If not user Day Trade exclude catalog daytrade
    var filteredCatalogs = (0,react.useMemo)(function() {
        return catalogs.filter(function(param) {
            var company_symbol = param.company_symbol;
            return showMultiplier || (company_symbol === null || company_symbol === void 0 ? void 0 : company_symbol.toLowerCase()) !== "daytrade";
        });
    }, [
        catalogs,
        showMultiplier
    ]);
    var onImgError = function() {
        setIsIconAvailable(false);
    };
    var formattedCountry = country.toLowerCase();
    var IMAGE_URL = "/img/flags/".concat(formattedCountry, ".png");
    var generateCatalogUrl = function(itemSector, itemSubSector) {
        if (!itemSector) return "";
        if (sector && sector.toLowerCase() !== "indeks") {
            return "/catalog/".concat((0,general/* convertToSlug */.k6)(itemSector), "/").concat((0,general/* convertToSlug */.k6)(itemSubSector));
        }
        return "/catalog/".concat((0,general/* convertToSlug */.k6)(itemSubSector));
    };
    var onClickCatalogsLink = function(event, companySymbol) {
        if (isGuestCompany) {
            event.preventDefault();
            onClickLink(true);
        } else {
            (0,clevertap/* clevertapEvent */.Lq)("Company Action", {
                Action: "emiten_group",
                Group: companySymbol
            });
        }
    };
    var handleSuccessFollow = function(following) {
        setIsFollowing(following);
    };
    var handleToggleFollow = function(following) {
        if (isGuestCompany) {
            onClickFollow();
            return false;
        }
        handleSuccessFollow(following);
        return true;
    };
    var handleOpenModal = (0,react.useCallback)(function() {
        setIsFollowCompanyVisible(true);
    }, [
        isFollowCompanyVisible
    ]);
    var handleCancelModal = (0,react.useCallback)(function() {
        setIsFollowCompanyVisible(false);
    }, [
        isFollowCompanyVisible
    ]);
    var handleClickBuyButton = (0,react.useCallback)(function() {
        var ref;
        buttonBuyRef === null || buttonBuyRef === void 0 ? void 0 : (ref = buttonBuyRef.current) === null || ref === void 0 ? void 0 : ref.click();
    }, [
        buttonBuyRef
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.param) === null || ref1 === void 0 ? void 0 : ref1[0]) === company_constants/* TAB_LIST_NAME.BUY */.p.BUY) {
            handleClickBuyButton();
        }
    }, [
        handleClickBuyButton,
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.param
    ]);
    var renderCatalogsLink = function(catalogue) {
        var subSectorObject = {
            "Properti & Real Estate": "Properti dan Real Estate",
            Commodities: "Commodity"
        };
        var companySymbol = catalogue.catalog_name || catalogue.company_symbol;
        var companySymbolAlias = subSectorObject[companySymbol] || catalogue.company_symbol;
        var companyType = catalogue.company_type;
        var catalogUrl = "";
        switch(companyType){
            case "sub_sector":
                catalogUrl = generateCatalogUrl(sector, companySymbolAlias);
                break;
            case "listing-board":
                catalogUrl = generateCatalogUrl(companyType, (0,general/* convertToSlug */.k6)(companySymbolAlias));
                break;
            default:
                catalogUrl = "/catalog/".concat(companyType, "/").concat(companySymbolAlias);
                break;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: catalogUrl,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CatalogButton */.WW, {
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: function(e) {
                    return onClickCatalogsLink(e, companySymbol);
                },
                children: companySymbol
            })
        });
    };
    var renderSymbol = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Symbol */.mN, {
            children: cleanSymbol(symbol.toUpperCase())
        });
    };
    var renderCountryFlag = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CountryFlagContainer */.Hr, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                className: "desktop",
                placement: "top",
                title: POPUP_COUNTRY_FLAG_TEXT,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CountryFlag */.AW, {
                    src: IMAGE_URL,
                    alt: "".concat(country, " flag")
                }, "country-flag-desktop")
            })
        });
    };
    var renderCountryFlagMobile = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CountryFlagContainerMobile */.vo, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CountryFlag */.AW, {
                className: "mobile",
                src: IMAGE_URL,
                alt: "".concat(country, " flag")
            }, "country-flag-mobile")
        });
    };
    var renderButtons = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonContainer */.qO, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FollowerWrapper */.E, {
                    as: "span",
                    onClick: function() {
                        return setIsFollowerVisible(true);
                    },
                    children: [
                        numeral_default()(followers).format("0,0"),
                        " followers"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowCompanyButton/* default */.Z, {
                    isFollowed: isFollowing,
                    onClick: handleOpenModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isTradeable && !isReksaDana(type_company) && profileCountry === "ID",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonBuy */.JQ, {
                        "data-cy": "company-buy-button",
                        onClick: onClickBuyButton,
                        ref: buttonBuyRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            weight: "bolder",
                            align: "center",
                            color: "inherit",
                            children: "Buy"
                        })
                    })
                })
            ]
        });
    };
    var renderButtonsMobile = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonContainerMobile */.Y8, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FollowerWrapper */.E, {
                    as: "span",
                    onClick: function() {
                        return setIsFollowerVisible(true);
                    },
                    children: [
                        numeral_default()(followers).format("0,0"),
                        " followers"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowCompanyButton/* default */.Z, {
                    isFollowed: isFollowing,
                    onClick: handleOpenModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isTradeable && !isReksaDana(type_company) && profileCountry === "ID",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonBuy */.JQ, {
                        onClick: onClickBuyButton,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            weight: "bolder",
                            align: "center",
                            color: "inherit",
                            children: "Buy"
                        })
                    })
                })
            ]
        });
    };
    var renderCompanyLogo = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ImageWrapper */.fb, {
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    children: [
                        isIconAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "company-header-icon",
                            src: icon_url,
                            onError: onImgError,
                            alt: symbol,
                            width: "54px",
                            height: "54px"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ImagePlaceholder */.Zc, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                children: !!symbol && symbol.toUpperCase().slice(0, 1)
                            })
                        }),
                        !!country && renderCountryFlagMobile()
                    ]
                }),
                renderButtonsMobile()
            ]
        });
    };
    var renderNotationCorpActionBadges = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationContainer */.SD, {
            children: (0,tags/* renderTags */.a)({
                symbol: symbol,
                uma: uma,
                notation: notation,
                corp_action: corp_action,
                name: name
            })
        });
    };
    var renderSuspendedDelistedBadges = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isSuspended && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Badges */.a9, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Suspended"
                    })
                }),
                isDelisted && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Badges */.a9, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Delisted"
                    })
                })
            ]
        });
    };
    var renderCompanyName = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CompanyName */.zo, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: name
            })
        });
    };
    var renderCompanyTags = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CompanyTags */.cr, {
            children: filteredCatalogs.slice(0, 6).map(function(catalogue) {
                return catalogue.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "catalogs",
                    children: renderCatalogsLink(catalogue)
                }, catalogue.company_symbol);
            })
        });
    };
    var renderExpandButtonToggle = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ExpandButtonToggleMobile */.U7, {
            onExpand: onExpandToggle
        });
    };
    var renderNotationCorpActionBar = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* NotationCorpActionBarWrapper */.dF, {
            // @ts-expect-error
            isCompanyStock: isCompanyStock,
            isBoth: isNotationAvailable && isCorpActionAvailable,
            children: [
                isNotationAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorBar/* default */.Z, {
                    symbol: symbol,
                    notation: notation,
                    uma: uma,
                    name: name,
                    isGuestCompanyStock: false,
                    onClick: onClickNotation
                }),
                isCorpActionAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(CorpActionBar/* default */.Z, {
                    symbol: symbol,
                    corpAction: corp_action,
                    isGuestCompanyStock: false,
                    onClick: onClickCorpAction,
                    typeCompany: type_company
                })
            ]
        });
    };
    // TODO: Should be fixed by SNE/V3 Rewrite
    var renderFollowerModal = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalFollower */.ZZ, {
            symbol: symbol,
            companyId: id,
            visible: isFollowerVisible,
            onCancel: function() {
                return setIsFollowerVisible(false);
            }
        });
    };
    var renderFollowModal = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalFollowing */.Mw, {
            visible: isFollowCompanyVisible,
            onCancel: handleCancelModal,
            companyId: id,
            onFollow: handleToggleFollow
        });
    };
    var renderCompanyHeader = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CompanyHeader */.ag, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CompanyIdentity */.GT, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CompanyInfoWrapper */.n4, {
                            $isIconAvailable: isIconAvailable,
                            children: [
                                renderCompanyLogo(),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CompanyNameContainer */.Yu, {
                                    children: [
                                        renderSymbol(),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* NotationCountryFlagContainer */.gv, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationPopoverBadgeContainer */.ZE, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverNotation/* default */.Z, {
                                                        company: company
                                                    })
                                                }),
                                                renderNotationCorpActionBadges(),
                                                !!country && renderCountryFlag(),
                                                renderSuspendedDelistedBadges()
                                            ]
                                        }),
                                        renderCompanyName(),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: profileCountry === "ID",
                                            children: renderCompanyTags()
                                        })
                                    ]
                                }),
                                renderExpandButtonToggle()
                            ]
                        }),
                        renderButtons()
                    ]
                }),
                renderNotationCorpActionBar(),
                renderFollowerModal(),
                renderFollowModal()
            ]
        });
    };
    return renderCompanyHeader();
}
/* harmony default export */ var company_Header = (Header);

// EXTERNAL MODULE: ./src/features/company/Chart/index.tsx + 3 modules
var Chart = __webpack_require__(82495);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/useLivePrice.ts
var useLivePrice = __webpack_require__(39767);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.types.ts
var liveprice_store_types = __webpack_require__(27934);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/utils.ts
var utils = __webpack_require__(24293);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/constants.ts
var AuthModal_constants = __webpack_require__(54855);
// EXTERNAL MODULE: ./src/global/Securities/utils/maintenance.ts + 2 modules
var maintenance = __webpack_require__(38525);
;// CONCATENATED MODULE: ./src/features/company/Hero/hero.clevertap.ts

var clevertapOnChangeTimeframe = function(symbol, timeframe) {
    (0,clevertap/* clevertapEvent */.Lq)("company_action", {
        Action: "change_timeframe",
        Stock: symbol,
        Date: timeframe
    });
};
var clevertapOnClickChart = function(symbol) {
    (0,clevertap/* clevertapEvent */.Lq)("company_action", {
        Action: "chartbit",
        Stock: symbol,
        Source: "Chart"
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/company/Hero/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  margin-bottom: 20px;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var HeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b26076ab-0"
})(_templateObject(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro);

;// CONCATENATED MODULE: ./src/features/company/Hero/index.tsx























function Hero(param) {
    var symbol = param.symbol;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,es/* useSelector */.v9)(company/* selectors */.wl), _detail = ref.detail, detailCompany = _detail.data, _chart = ref.chart, chartCompany = _chart.data, isLoadingChart = _chart.isLoading;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref1.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref2 = (0,react.useState)(true), showMainChart = ref2[0], setShowMainChart = ref2[1];
    var ref3 = (0,react.useState)(false), loadingFollow = ref3[0], setLoadingFollow = ref3[1];
    var ref4 = (0,react.useState)(company_constants/* chartTimeframes.0.value */.Iv[0].value), timeframe = ref4[0], setTimeframe = ref4[1];
    var ref5 = (0,react.useState)({}), companyData = ref5[0], setCompanyData = ref5[1];
    var onExpandToggle = function() {
        return setShowMainChart(!showMainChart);
    };
    var currentCompany = (0,react.useMemo)(function() {
        return (detailCompany === null || detailCompany === void 0 ? void 0 : detailCompany[symbol]) || {};
    }, [
        detailCompany
    ]);
    var handleClickChart = (0,react.useCallback)(function() {
        return clevertapOnClickChart(symbol);
    }, [
        symbol
    ]);
    var handleSetTimeframe = (0,react.useCallback)(function(v) {
        setTimeframe(v);
        clevertapOnChangeTimeframe(symbol, v);
    }, [
        symbol,
        setTimeframe
    ]);
    var handleToggleFollow = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, watchlistId, data, action, follow;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = auth/* default.getUserAccess */.Z.getUserAccess(), watchlistId = ref.watchlist_id;
                        data = {
                            watchlistId: watchlistId,
                            companyId: currentCompany.id,
                            stateToUpdate: company/* STATE_DETAIL */._P
                        };
                        action = currentCompany.followed ? company/* effects.postUnfollowCompany */.Sz.postUnfollowCompany : company/* effects.postFollowCompany */.Sz.postFollowCompany;
                        setLoadingFollow(true);
                        _ctx.next = 6;
                        return dispatch(action(data));
                    case 6:
                        follow = _ctx.sent;
                        if (follow) {
                            setLoadingFollow(false);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleToggleFollow() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenCorpAction = function(e) {
        e.preventDefault();
        router.push("symbol/".concat(symbol, "/corpaction"));
    };
    var handleBuyButton = function() {
        return (0,maintenance/* withMaintenanceGuard */.L)(function() {
            (0,utils/* showTradingModalWithAuth */.Y)({
                symbol: symbol,
                orderType: AuthModal_constants/* AUTH_ORDER_TYPE.BUY */.q.BUY
            });
        });
    };
    (0,react.useEffect)(function() {
        if (timeframe && showMainChart) {
            var params = {
                symbol: symbol,
                timeframe: timeframe
            };
            dispatch(company/* effects.getCompanyChart */.Sz.getCompanyChart(params));
        }
    }, [
        dispatch,
        symbol,
        showMainChart,
        timeframe
    ]);
    (0,react.useEffect)(function() {
        if (detailCompany[symbol]) {
            setCompanyData(function(prevState) {
                return (0,_object_spread/* default */.Z)({}, prevState, detailCompany[symbol]);
            });
        }
    }, [
        detailCompany
    ]);
    var livePriceOnMessage = (0,react.useCallback)(function(param) {
        var date = param.date, lastprice = param.lastprice, change = param.change, percentage = param.percentage_change, volume = param.volume;
        setCompanyData(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                price: lastprice,
                change: change,
                percentage: percentage,
                volume: volume,
                time: moment_default()(date).format("ddd HH:mm")
            });
        });
    }, []);
    (0,useLivePrice/* useLivePrice */.L)([
        symbol
    ], liveprice_store_types/* LivePriceSymbolsKeyEnum.COMPANY_HERO */.j.COMPANY_HERO, "company", livePriceOnMessage);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Header, {
                symbol: symbol,
                company: currentCompany,
                isLoadingFollow: loadingFollow,
                onClickNotation: function() {},
                onClickFollow: handleToggleFollow,
                onClickCorpAction: handleOpenCorpAction,
                onClickBuyButton: handleBuyButton,
                onExpandToggle: onExpandToggle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: country === "ID",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                    symbol: symbol,
                    company: companyData,
                    isLoadingChart: isLoadingChart,
                    chart: chartCompany === null || chartCompany === void 0 ? void 0 : chartCompany[symbol],
                    timeframe: timeframe,
                    isChartVisible: showMainChart,
                    onExpand: onExpandToggle,
                    onSelectTimeFrame: handleSetTimeframe,
                    onClickChart: handleClickChart
                })
            })
        ]
    });
}
/* harmony default export */ var company_Hero = (Hero);

;// CONCATENATED MODULE: ./src/features/company/index.clevertap.ts


var clevertapCompanyViewed = function(company) {
    var sectoralIndex = company.indexes_data.find(function(s) {
        return s.company_type === "indeks-sektoral";
    });
    var companyStatus = (0,general/* capitalizeFirstLetter */.fm)(company.status.replace("STATUS_", ""));
    var ref;
    var clevertapParams = {
        Symbol: company.symbol_2 || company.symbol,
        Name: company.name,
        Followers: company.followers,
        "Current Price": parseFloat(company.price),
        "Price Change": parseFloat(company.change),
        "Percentage Change": company.percentage,
        Exchange: company.exchange,
        "Asset Type": company.type_company,
        "Sectoral Index": (ref = sectoralIndex === null || sectoralIndex === void 0 ? void 0 : sectoralIndex.company_symbol) !== null && ref !== void 0 ? ref : "",
        Sector: company.sector,
        "Sub-Sector": company.sub_sector,
        "Is Watchlist Item": !!company.followed,
        "Is Corporate Action": !!company.corp_action.active,
        "Is Special Notation": !!company.notation.length,
        "Company Status": companyStatus
    };
    (0,clevertap/* clevertapEvent */.Lq)("Company Page Viewed", clevertapParams);
};

// EXTERNAL MODULE: ./src/features/company/store.ts
var company_store = __webpack_require__(26446);
;// CONCATENATED MODULE: ./src/features/company/index.tsx
























var NotFound = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 79136).then(__webpack_require__.bind(__webpack_require__, 79136));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79136)
            ];
        }
    },
    ssr: false
});
var Stream = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(60296), __webpack_require__.e(98294), __webpack_require__.e(57333), __webpack_require__.e(5406), __webpack_require__.e(48761), __webpack_require__.e(46066), __webpack_require__.e(25675), __webpack_require__.e(54240), __webpack_require__.e(74673), __webpack_require__.e(36902), __webpack_require__.e(41232), __webpack_require__.e(82583), __webpack_require__.e(79624), __webpack_require__.e(42234), __webpack_require__.e(14467), __webpack_require__.e(87109), __webpack_require__.e(70536), __webpack_require__.e(12104), __webpack_require__.e(61442), __webpack_require__.e(37376), __webpack_require__.e(42293), __webpack_require__.e(28287), __webpack_require__.e(74749), __webpack_require__.e(10605), __webpack_require__.e(95880), __webpack_require__.e(83668), __webpack_require__.e(4965), __webpack_require__.e(46881), __webpack_require__.e(72749)]).then(__webpack_require__.bind(__webpack_require__, 87342));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87342)
            ];
        }
    },
    ssr: false
});
var Insider = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(23391), __webpack_require__.e(68939)]).then(__webpack_require__.bind(__webpack_require__, 68939));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68939)
            ];
        }
    },
    ssr: false
});
var Seasonality = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(23391), __webpack_require__.e(92144)]).then(__webpack_require__.bind(__webpack_require__, 92144));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92144)
            ];
        }
    },
    ssr: false
});
var Keystat = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(23391), __webpack_require__.e(5584)]).then(__webpack_require__.bind(__webpack_require__, 5584));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5584)
            ];
        }
    },
    ssr: false
});
var Comparison = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(54663), __webpack_require__.e(23391), __webpack_require__.e(40743)]).then(__webpack_require__.bind(__webpack_require__, 40743));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40743)
            ];
        }
    },
    ssr: false
});
var Financial = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(54663), __webpack_require__.e(23391), __webpack_require__.e(35841)]).then(__webpack_require__.bind(__webpack_require__, 35841));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35841)
            ];
        }
    },
    ssr: false
});
var Fundachart = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63085), __webpack_require__.e(55520), __webpack_require__.e(36941), __webpack_require__.e(81677)]).then(__webpack_require__.bind(__webpack_require__, 81677));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81677)
            ];
        }
    },
    ssr: false
});
var Paywall = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(74673), __webpack_require__.e(16823)]).then(__webpack_require__.bind(__webpack_require__, 16823));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16823)
            ];
        }
    },
    ssr: false
});
var Analyst = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(21757), __webpack_require__.e(52034), __webpack_require__.e(23391), __webpack_require__.e(19852), __webpack_require__.e(29682)]).then(__webpack_require__.bind(__webpack_require__, 29682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29682)
            ];
        }
    },
    ssr: false
});
var Profile = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(51524), __webpack_require__.e(14078), __webpack_require__.e(23391), __webpack_require__.e(23120), __webpack_require__.e(12218)]).then(__webpack_require__.bind(__webpack_require__, 20153));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20153)
            ];
        }
    },
    ssr: false
});
var Consensus = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(23391), __webpack_require__.e(19852)]).then(__webpack_require__.bind(__webpack_require__, 19852));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19852)
            ];
        }
    },
    ssr: false
});
var CorpAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 96657).then(__webpack_require__.bind(__webpack_require__, 96657));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96657)
            ];
        }
    },
    ssr: false
});
var FRPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(47292), __webpack_require__.e(69907)]).then(__webpack_require__.bind(__webpack_require__, 69907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69907)
            ];
        }
    },
    ssr: false
});
var COMPANY_SYMBOL_COMPONENTS = (0,_define_property/* default */.Z)({}, company_constants/* TAB_LIST_NAME.CONSENSUS */.p.CONSENSUS, Consensus);
var _obj;
var COMPANY_SYMBOL_PRO_COMPONENTS = (_obj = {}, (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.KEYSTATS */.p.KEYSTATS, Keystat), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.FINANCIALS */.p.FINANCIALS, Financial), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.FUNDACHART */.p.FUNDACHART, Fundachart), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.SEASONALITY */.p.SEASONALITY, Seasonality), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.COMPARISON */.p.COMPARISON, Comparison), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST, Analyst), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.INSIDER */.p.INSIDER, Insider), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.PROFILE */.p.PROFILE, Profile), (0,_define_property/* default */.Z)(_obj, company_constants/* TAB_LIST_NAME.CORP_ACTION_NEW_NAME */.p.CORP_ACTION_NEW_NAME, CorpAction), _obj);
function Company(param) {
    var symbol = param.symbol, tab = param.tab;
    var ref;
    var isLoaded = (0,useProtectedRoute/* default */.Z)().isLoaded;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,es/* useSelector */.v9)(company/* selectors */.wl), _detail = ref1.detail, companyData = _detail.data, error = _detail.error;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var userId = data.id, country = data.country;
    var ref2 = (0,react.useState)(""), activeTab = ref2[0], setActiveTab = ref2[1];
    var setCompanyLoading = (0,company_store/* useCompanyStore */.J)(function(param) {
        var setLoading = param.setLoading;
        return setLoading;
    });
    var paywallTab = tab === company_constants/* TAB_LIST_NAME.BUY */.p.BUY ? undefined : tab;
    store_useCompany(paywallTab, symbol);
    (0,react.useEffect)(function() {
        setCompanyLoading(true);
        dispatch(slice/* default.actions.updateLoadingState */.ZP.actions.updateLoadingState({
            isLoading: true
        }));
    }, []);
    (0,react.useEffect)(function() {
        if (symbol) {
            var getCompanyDetail = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var ref, _payload, companyDetailError, companyDetailData;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return dispatch(company/* effects.getCompanyDetail */.Sz.getCompanyDetail(symbol));
                            case 2:
                                ref = _ctx.sent;
                                _payload = ref.// @ts-ignore
                                payload;
                                companyDetailError = _payload.error;
                                companyDetailData = _payload.data;
                                // @ts-ignore
                                if (!companyDetailError && companyDetailData) {
                                    clevertapCompanyViewed(companyDetailData);
                                }
                            case 7:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function getCompanyDetail() {
                    return _ref.apply(this, arguments);
                };
            }();
            getCompanyDetail();
        }
    }, [
        dispatch,
        symbol
    ]);
    (0,react.useEffect)(function() {
        if (tab) {
            setCompanyLoading(true);
            dispatch(slice/* default.actions.updateLoadingState */.ZP.actions.updateLoadingState({
                isLoading: true
            }));
            setActiveTab(tab);
        }
    }, [
        tab
    ]);
    if (!symbol || !companyData[symbol]) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
            ]
        });
    }
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound, {});
    }
    var currentCompany = companyData[symbol];
    var streamTabs = [
        company_constants/* TAB_LIST_NAME.HOME */.p.HOME,
        company_constants/* TAB_LIST_NAME.STREAM */.p.STREAM,
        company_constants/* TAB_LIST_NAME.NEWS */.p.NEWS,
        company_constants/* TAB_LIST_NAME.BUY */.p.BUY, 
    ];
    var proTabs = [
        company_constants/* TAB_LIST_NAME.FUNDACHART */.p.FUNDACHART,
        company_constants/* TAB_LIST_NAME.FINANCIALS */.p.FINANCIALS,
        company_constants/* TAB_LIST_NAME.KEYSTATS */.p.KEYSTATS,
        company_constants/* TAB_LIST_NAME.COMPARISON */.p.COMPARISON,
        company_constants/* TAB_LIST_NAME.SEASONALITY */.p.SEASONALITY,
        company_constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST,
        company_constants/* TAB_LIST_NAME.INSIDER */.p.INSIDER,
        company_constants/* TAB_LIST_NAME.PROFILE */.p.PROFILE,
        company_constants/* TAB_LIST_NAME.CORP_ACTION_NEW_NAME */.p.CORP_ACTION_NEW_NAME, 
    ];
    var tabs = ((ref = companyData[symbol]) === null || ref === void 0 ? void 0 : ref.tabs) || [];
    if (country === "MY" && tabs.length > 0) tabs = [
        "stream"
    ];
    var companyTabs = tabs.filter(function(value) {
        return value !== company_constants/* TAB_LIST_NAME.NEWS */.p.NEWS;
    }).map(function(value) {
        var newValue = value;
        if (value === company_constants/* TAB_ANALYST_NEW_NAME */.K1) {
            newValue = company_constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST;
        }
        return company_constants/* TAB_LIST */.YS[newValue];
    });
    var isTabsIncluded = function(tabList, name) {
        return Object.values(tabList).includes(name);
    };
    var renderTabContent = function(tabName) {
        var isPro = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref;
        var companySymbolComponentList = isPro ? COMPANY_SYMBOL_PRO_COMPONENTS : COMPANY_SYMBOL_COMPONENTS;
        var Component = companySymbolComponentList === null || companySymbolComponentList === void 0 ? void 0 : companySymbolComponentList[tabName];
        return Component ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
            symbol: symbol,
            companyType: (ref = companyData[symbol]) === null || ref === void 0 ? void 0 : ref.type_company
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    var clevertapEventAction = function(name) {
        var ref, ref1, ref2, ref3, ref4;
        var clevertapEventActionEnum = company_d/* CompanyActionEnums */.F;
        var newName = name.toUpperCase();
        var action = clevertapEventActionEnum[newName];
        var isFCA = (ref = companyData[symbol]) === null || ref === void 0 ? void 0 : (ref1 = ref.notation) === null || ref1 === void 0 ? void 0 : ref1.some(function(item) {
            return (item === null || item === void 0 ? void 0 : item.notation_code) === "X";
        });
        var notation = (ref2 = companyData[symbol]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.notation) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.notation_code;
        });
        var eventReturn = {
            eventName: constants_clevertap/* CLEVERTAP_EVENT_NAME.COMPANY_MENU */.dR.COMPANY_MENU,
            eventPayload: {
                Action: action,
                Stock: symbol,
                Company_Type: (ref4 = companyData[symbol]) === null || ref4 === void 0 ? void 0 : ref4.type_company,
                Is_FCA: isFCA
            }
        };
        if (notation.length > 0) {
            eventReturn.eventPayload.Special_Notation = notation.toString();
        }
        return eventReturn;
    };
    /**
   * Send CleverTap Event. "analyst" & "seasonality" event not same as the others.
   * @param {Object} eventParams
   * @param {
   * "analyst" | "stream" | "news" | "keystats" |
   * "financials" | "fundachart" | "seasonality" |
   * "chartbit" | "comparison" | "insider" | "profile" |
   * "corp.action"
   * } eventParams.tabPath Company Tab Name
   * @param {number} eventParams.timeout timeout before sending event in ms
   */ var sendCleverTapEvent = function(param) {
        var tabPath = param.tabPath, _timeout = param.timeout, timeout = _timeout === void 0 ? 0 : _timeout;
        var isStreamTabs = isTabsIncluded(streamTabs, tabPath);
        var newTabPath = isStreamTabs ? company_constants/* TAB_LIST_NAME.STREAM */.p.STREAM : tabPath;
        var ref = clevertapEventAction(newTabPath), eventName = ref.eventName, eventPayload = ref.eventPayload;
        if (newTabPath === company_constants/* TAB_LIST_NAME.CHARTBIT */.p.CHARTBIT) {
            eventPayload.Source = company_constants/* SOURCE_MENU */.R1;
        }
        setTimeout(function() {
            try {
                (0,clevertap/* clevertapEvent */.Lq)(eventName, eventPayload);
            } catch (_error) {
                ;
            }
        }, timeout);
    };
    if ((currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.type_company) === "FR") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QueryProvider/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                    title: "".concat(currentCompany.symbol, " ").concat(currentCompany.name, " on Stockbit")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader["default"], {
                    loaded: isLoaded
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FRPage, {
                    symbol: symbol
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "".concat(currentCompany.symbol, " ").concat(currentCompany.name, " on Stockbit")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader["default"], {
                loaded: isLoaded
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_Hero, {
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                tabs: companyTabs,
                active: activeTab,
                onSendClevertapEvent: sendCleverTapEvent,
                isLoggedIn: isLoggedIn,
                userId: userId,
                className: country.toLowerCase()
            }),
            isTabsIncluded(streamTabs, activeTab) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stream, {
                activeNav: activeTab,
                symbol: symbol
            }),
            isTabsIncluded(proTabs, activeTab) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paywall, {
                source: activeTab,
                symbol: symbol,
                children: renderTabContent(activeTab, true)
            }),
            renderTabContent(activeTab)
        ]
    });
}
/* harmony default export */ var features_company = (Company);


/***/ }),

/***/ 26446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useCompanyStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14671);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1349);






var holdingCompositionInitialState = {
    data: {},
    error: {},
    isLoading: false
};
var corpActionInitialState = {};
// Initial State
var initialState = {
    profile: {},
    holdingComposition: holdingCompositionInitialState,
    corpAction: corpActionInitialState,
    consensus: {},
    insider: {},
    seasonality: {},
    keystat: {},
    pricePerformance: {},
    financial: {},
    analyst: {},
    analystConsensus: {},
    isLoading: false,
    isLoadingAnalystConsensus: false,
    message: "",
    error: null,
    errorPricePerformance: {},
    financialParams: {
        report: 1,
        statement: 1
    },
    pinnedPost: {
        data: {},
        isLoading: {},
        message: {},
        error: {}
    }
};
var companyActions = function(set) {
    return {
        setLoading: function(value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.isLoading = value;
                });
            });
        },
        getCompanyKeystat: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
                var getKeystat, _data, _$error, data, message;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.isLoading = true;
                                });
                            });
                            _ctx.next = 4;
                            return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyKeystat */ .Z.getCompanyKeystat(symbol);
                        case 4:
                            getKeystat = _ctx.sent;
                            if (getKeystat.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Attempt to get company keystat failed");
                        case 7:
                            _data = getKeystat.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                            if (!_$error) {
                                _ctx.next = 11;
                                break;
                            }
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.error = _$error;
                                    draft.message = message;
                                });
                            });
                            return _ctx.abrupt("return", {
                                error: _$error,
                                message: message
                            });
                        case 11:
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.keystat[symbol] = data;
                                });
                            });
                            return _ctx.abrupt("return", {
                                data: data,
                                symbol: symbol
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.error = _ctx.t0;
                                });
                            });
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                            _ctx.prev = 19;
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.isLoading = false;
                                });
                            });
                            return _ctx.finish(19);
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15,
                        19,
                        22
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        getCompanyPricePerformance: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
                var getPricePerformance, _data, _$error, data, message;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.isLoading = true;
                                });
                            });
                            _ctx.next = 4;
                            return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyPricePerformance */ .Z.getCompanyPricePerformance(symbol);
                        case 4:
                            getPricePerformance = _ctx.sent;
                            if (getPricePerformance.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Attempt to get company keystat failed");
                        case 7:
                            _data = getPricePerformance.data, _$error = _data.error_type, data = _data.data, message = _data.message;
                            if (!_$error) {
                                _ctx.next = 11;
                                break;
                            }
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.errorPricePerformance = _$error;
                                });
                            });
                            return _ctx.abrupt("return", {
                                error: _$error,
                                message: message
                            });
                        case 11:
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.pricePerformance[symbol] = data === null || data === void 0 ? void 0 : data.prices;
                                });
                            });
                            return _ctx.abrupt("return", {
                                data: data,
                                symbol: symbol
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.errorPricePerformance = _ctx.t0;
                                });
                            });
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                            _ctx.prev = 19;
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.isLoading = false;
                                });
                            });
                            return _ctx.finish(19);
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15,
                        19,
                        22
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }()
    };
};
var useCompanyStore = (0,zustand__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState, companyActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 11298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ PAYWALL_IMAGE_URL; },
/* harmony export */   "LB": function() { return /* binding */ CompanyStreamWidget; },
/* harmony export */   "RQ": function() { return /* binding */ DescriptionText; },
/* harmony export */   "Up": function() { return /* binding */ ButtonNewText; },
/* harmony export */   "Uw": function() { return /* binding */ CompanyWidgetEnum; },
/* harmony export */   "cY": function() { return /* binding */ ButtonContinueText; },
/* harmony export */   "gQ": function() { return /* binding */ CompanyWidgetTitle; },
/* harmony export */   "oz": function() { return /* binding */ OfferingPro; },
/* harmony export */   "pj": function() { return /* binding */ OfferingProText; },
/* harmony export */   "qU": function() { return /* binding */ PaywallFeatureEnum; },
/* harmony export */   "t9": function() { return /* binding */ AddOnWidget; },
/* harmony export */   "z": function() { return /* binding */ HeaderText; }
/* harmony export */ });
/* unused harmony exports IncludedNavbar, ExcludeOldPro, ExcludeOldProPage */
/* eslint-disable no-shadow */ var HeaderText = "Kuota Akses Bulanan Sudah Mencapai Limit";
var DescriptionText = "Nikmati akses seluruh fitur tanpa batas dengan membuka rekening saham di Stockbit Sekuritas.";
var ButtonNewText = "Buka Akses";
var ButtonContinueText = "Lanjut Berlangganan";
var PAYWALL_IMAGE_URL = "/img/paywall";
var OfferingPro = {
    open: {
        title: "Buka Rekening Saham",
        description: "Trading saham di Stockbit Sekuritas dan nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-open-icon.svg")
    },
    subscribe: {
        title: "Berlangganan",
        description: "Berlangganan mulai dari Rp15 ribu/hari untuk nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-subscribe-icon.svg")
    }
};
var OfferingProText = {
    headline: "Nikmati Seluruh Fitur",
    underlined: "Profesional Stockbit",
    unlimited: "Tanpa Batas"
};
var PaywallFeatureEnum;
(function(PaywallFeatureEnum) {
    PaywallFeatureEnum["DEFAULT"] = "PAYWALL_FEATURE_UNSPECIFIED";
    PaywallFeatureEnum["KEYSTATS"] = "PAYWALL_FEATURE_KEYSTATS";
    PaywallFeatureEnum["ANALYST"] = "PAYWALL_FEATURE_ANALYSIS";
    PaywallFeatureEnum["FINANCIALS"] = "PAYWALL_FEATURE_FINANCIALS";
    PaywallFeatureEnum["FUNDACHART"] = "PAYWALL_FEATURE_FUNDACHART";
    PaywallFeatureEnum["SEASONALITY"] = "PAYWALL_FEATURE_SEASONALITY";
    PaywallFeatureEnum["CHARTBIT"] = "PAYWALL_FEATURE_CHARTBIT";
    PaywallFeatureEnum["COMPARISON"] = "PAYWALL_FEATURE_COMPARISON";
    PaywallFeatureEnum["INSIDER"] = "PAYWALL_FEATURE_INSIDER";
    PaywallFeatureEnum["PROFILE"] = "PAYWALL_FEATURE_COMPANY_PROFILE";
    PaywallFeatureEnum["CORPACTION"] = "PAYWALL_FEATURE_CORP_ACTION";
    PaywallFeatureEnum["PRICE_ALERT"] = "PAYWALL_FEATURE_PRICE_ALERT";
    PaywallFeatureEnum["RUNNING_TRADE"] = "PAYWALL_FEATURE_RUNNING_TRADE";
    PaywallFeatureEnum["VALUATION"] = "PAYWALL_FEATURE_VALUATION";
    PaywallFeatureEnum["BANDAR_DETECTOR"] = "PAYWALL_FEATURE_BANDAR_DETECTOR";
    PaywallFeatureEnum["ORDERBOOK"] = "PAYWALL_FEATURE_ORDERBOOK";
    PaywallFeatureEnum["SCREENER"] = "PAYWALL_FEATURE_SCREENER";
    PaywallFeatureEnum["CALENDAR"] = "PAYWALL_FEATURE_CALENDAR";
    PaywallFeatureEnum["EARNINGS"] = "PAYWALL_FEATURE_EARNINGS";
})(PaywallFeatureEnum || (PaywallFeatureEnum = {}));
var CompanyWidgetEnum;
(function(CompanyWidgetEnum) {
    CompanyWidgetEnum["FUNDACHART"] = "FUNDACHART";
    CompanyWidgetEnum["SEASONALITY"] = "SEASONALITY";
    CompanyWidgetEnum["COMPARISON"] = "COMPARISON";
    CompanyWidgetEnum["FINANCIALS"] = "FINANCIALS";
})(CompanyWidgetEnum || (CompanyWidgetEnum = {}));
var IncludedNavbar = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "SCREENER",
    "VALUATION",
    "CALENDAR",
    "EARNINGS", 
]));
var CompanyStreamWidget = [
    "ORDERBOOK",
    "RUNNING_TRADE"
];
var CompanyWidgetTitle = {
    ORDERBOOK: "Orderbook",
    RUNNING_TRADE: "Running Trade",
    TRADE_BOOK: "Trade Book",
    BROKER_SUMMARY: "Broker Summary"
};
var AddOnWidget = "VALUATION";
var ExcludeOldPro = (/* unused pure expression or super */ null && ([
    "analyst",
    "insider",
    "profile",
    "corpaction"
]));
var ExcludeOldProPage = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "CALENDAR",
    "EARNINGS"
]));



/***/ }),

/***/ 92182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
;// CONCATENATED MODULE: ./src/lib/api/paywall.ts

var request = (0,requestExodus/* default */.Z)(false);
var GET_ELIGIBILITY_STATUS = "/paywall/eligibility/check";
var POST_PAYWALL_COUNTER = "/paywall/counter/increment";
var getPaywallStatus = function(param) {
    var company = param.company, feature = param.feature;
    var params = {
        features: feature
    };
    if (company) {
        params.company = company;
    }
    return request.get(GET_ELIGIBILITY_STATUS, {
        params: params
    });
};
var getMultipleStatus = function(payload) {
    var company = payload.company, feature = payload.feature;
    var companyQs = company ? "company=".concat(company, "&") : "";
    var featuresQs = feature.map(function(f) {
        return "features=".concat(f);
    }).join("&");
    return request.get("".concat(GET_ELIGIBILITY_STATUS, "?").concat(companyQs).concat(featuresQs));
};
var addPaywallCounter = function(param) {
    var company = param.company, feature = param.feature;
    var body = {
        feature: feature
    };
    if (company) {
        body.company = company;
    }
    return request.post(POST_PAYWALL_COUNTER, body);
};
/* harmony default export */ var paywall = ({
    getPaywallStatus: getPaywallStatus,
    getMultipleStatus: getMultipleStatus,
    addPaywallCounter: addPaywallCounter
});

;// CONCATENATED MODULE: ./src/features/paywall/store/index.ts








var sectionState = {
    isLoading: false,
    isRenewal: false,
    isPro: false,
    data: {
        features: [],
        last_subscription: null,
        company: null
    }
};
var initialState = {
    page: sectionState,
    company: sectionState,
    widget: sectionState
};
var useStorePaywall = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        getStatus: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var ref, key, feature, company, isMultiple, payloadFeature, response, data, ref1, newData, ref2, ref3, selectedData, _is_eligible, defaultError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            key = payload.key, feature = payload.feature, company = payload.company;
                            isMultiple = Array.isArray(feature) && feature.length > 1;
                            payloadFeature = isMultiple ? feature[0] : feature;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[key].isLoading = true;
                            }));
                            if (!isMultiple) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 9;
                            return paywall.getMultipleStatus(payload);
                        case 9:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.next = 14;
                            return paywall.getPaywallStatus(payload);
                        case 14:
                            _ctx.t0 = _ctx.sent;
                        case 15:
                            response = _ctx.t0;
                            if (!(!response || !response.data || !response.data.data)) {
                                _ctx.next = 18;
                                break;
                            }
                            throw new Error("Error while fetching paywall status");
                        case 18:
                            data = response.data.data;
                            ;
                            newData = {
                                isPro: false,
                                isRenewal: (ref1 = (data === null || data === void 0 ? void 0 : data.last_subscription) !== null) !== null && ref1 !== void 0 ? ref1 : false,
                                isLoading: false,
                                data: data
                            };
                            if (!(company && data.company)) {
                                _ctx.next = 27;
                                break;
                            }
                            ;
                            ;
                            newData.isPro = (ref3 = (ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.is_eligible) !== null && ref3 !== void 0 ? ref3 : false;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 27:
                            selectedData = (ref = data.features) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                                return item.feature === payloadFeature;
                            });
                            if (selectedData) {
                                ;
                                newData.isPro = (_is_eligible = selectedData.is_eligible) !== null && _is_eligible !== void 0 ? _is_eligible : false;
                            }
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 33:
                            _ctx.prev = 33;
                            _ctx.t1 = _ctx["catch"](0);
                            defaultError = "Unknown error while fetching paywall status";
                            if (!(0,_instanceof/* default */.Z)(_ctx.t1, Error)) {
                                _ctx.next = 39;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return", _ctx.t1.message);
                        case 39:
                            ;
                            return _ctx.abrupt("return", defaultError);
                        case 41:
                            _ctx.prev = 41;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[payload.key].isLoading = false;
                            }));
                            return _ctx.finish(41);
                        case 44:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        33,
                        41,
                        44
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        addCounter: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var response, _data, error, errorType, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return paywall.addPaywallCounter(payload);
                        case 3:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while post paywall counter");
                        case 6:
                            _data = response.data, error = _data.error, errorType = _data.error_type, message = _data.message;
                            if (!(error || errorType)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(message);
                        case 9:
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!(0,_instanceof/* default */.Z)(_ctx.t0, Error)) {
                                _ctx.next = 17;
                                break;
                            }
                            ;
                            return _ctx.abrupt("return");
                        case 17:
                            ;
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetProStatus: function(key) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state[key].isPro = false;
            }));
        }
    });
});
/* harmony default export */ var store = (useStorePaywall);


/***/ }),

/***/ 5072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SectionEnum; }
/* harmony export */ });
var SectionEnum;
(function(SectionEnum) {
    SectionEnum["page"] = "page";
    SectionEnum["company"] = "company";
    SectionEnum["widget"] = "widget";
})(SectionEnum || (SectionEnum = {}));


/***/ }),

/***/ 88679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var global_Common_If__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3897);
/* harmony import */ var _CorpActionTag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66988);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27691);
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/anchor-is-valid */ 







function CorpActionBar(param) {
    var symbol = param.symbol, corpAction = param.corpAction, _isGuestCompanyStock = param.isGuestCompanyStock, isGuestCompanyStock = _isGuestCompanyStock === void 0 ? false : _isGuestCompanyStock, onClick = param.onClick, _typeCompany = param.typeCompany, typeCompany = _typeCompany === void 0 ? "" : _typeCompany;
    var onClickLink = function(event) {
        return isGuestCompanyStock ? onClick(event) : false;
    };
    var formatComma = function(number) {
        return new Intl.NumberFormat("en-US").format(number);
    };
    var getPriceText = function() {
        if (typeCompany.toLowerCase() === "waran") return "Exercise Price";
        if (typeCompany.toLowerCase() === "right") return "Right Issue Price";
        return "";
    };
    var renderText = function() {
        if (corpAction.detail) {
            if (typeCompany.toLowerCase() === "waran" || typeCompany.toLowerCase() === "right") {
                var ref, ref1, ref2, ref3, ref4;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        as: "span",
                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis,
                        weight: "600",
                        ml: "8px",
                        size: "12px",
                        children: [
                            getPriceText(),
                            ": ",
                            formatComma((ref = corpAction.detail) === null || ref === void 0 ? void 0 : ref.price),
                            " •",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                style: {
                                    fontWeight: 400
                                },
                                children: [
                                    "Trading End: ",
                                    (ref1 = corpAction.detail) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.trading_end_date) === null || ref2 === void 0 ? void 0 : ref2.formatted,
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(global_Common_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        condition: typeCompany.toLowerCase() === "waran",
                                        children: [
                                            "• Exercise End:",
                                            " ",
                                            (ref3 = corpAction.detail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.exercise_end_date) === null || ref4 === void 0 ? void 0 : ref4.formatted
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "span",
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis,
                weight: "600",
                ml: "8px",
                size: "12px",
                children: "Perusahaan memiliki Corporate Action"
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
        href: "/symbol/".concat(symbol, "/corpaction"),
        passHref: true,
        onClick: onClickLink,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_7__/* .BarWrapper */ .iG, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CorpActionTag__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                corpAction: corpAction
                            }),
                            renderText()
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__/* .IconArrow */ .CC, {
                        as: "span"
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CorpActionBar);


/***/ }),

/***/ 39767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useLivePrice; }
/* harmony export */ });
/* harmony import */ var _useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65131);
/* harmony import */ var _useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35320);


var useLivePrice = function(symbols, stateKey, actionKey, onMessage) {
    (0,_useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceSender */ .O)(stateKey, symbols);
    (0,_useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_0__/* .useLivePriceReceiver */ .V)(symbols, actionKey, onMessage);
};


/***/ }),

/***/ 65131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useLivePriceReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49696);
/* harmony import */ var _useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7538);





var useLivePriceReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var liveprice, formattedLivePrice;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        liveprice = (message || {}).liveprice;
                        if (liveprice && stringSymbols.split(",").includes(liveprice.stockCode)) {
                            formattedLivePrice = (0,_useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__/* .natsLivePriceFormatter */ .XA)(liveprice);
                            onMessage(formattedLivePrice, liveprice);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("liveprice", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};


/***/ }),

/***/ 598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_PageLoader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Loading/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0;\n      visibility: hidden;\n      z-index: 1;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: white;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  opacity: 1;\n  position: fixed;\n  top: 0;\n  transition: all 0.3s ease-in-out;\n  visibility: visible;\n  width: 100%;\n  z-index: 1050;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  background-color: #333;\n  margin: 0 5px;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  transform-origin: center center;\n\n  &:first-child {\n    -webkit-animation-delay: -0.32s;\n    animation-delay: -0.32s;\n  }\n\n  &:nth-child(2) {\n    -webkit-animation-delay: -0.16s;\n    animation-delay: -0.16s;\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n      transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n  }\n\n  @-webkit-keyframes sk-bouncedelay {\n    0%,\n    80%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    40% {\n      -webkit-transform: scale(1);\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-0"
})(_templateObject1(), function(param) {
    var loaded = param.loaded;
    return loaded && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Bouncer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-372f28a1-1"
})(_templateObject2());


;// CONCATENATED MODULE: ./src/global/Loading/Bouncer.tsx





var Bouncer_Bouncer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bouncer, {})
            ]
        })
    });
};
/* harmony default export */ var Loading_Bouncer = (Bouncer_Bouncer);

;// CONCATENATED MODULE: ./src/global/Loading/PageLoader.jsx





function PageLoader(param) {
    var loaded = param.loaded;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
        loaded: loaded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_Bouncer, {})
    });
}
PageLoader.propTypes = {
    loaded: (prop_types_default()).bool
};
PageLoader.defaultProps = {
    loaded: false
};
// always re-render (event no visual visiblity) => need memo
/* harmony default export */ var Loading_PageLoader = (/*#__PURE__*/react.memo(PageLoader));


/***/ }),

/***/ 52491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _Content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92292);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69836);







var INDICATOR_ICON_URL = "/icon/ic_indicator.svg";
function IndicatorBar(param) {
    var symbol = param.symbol, uma = param.uma, notation = param.notation, name = param.name, _type = param.type, type = _type === void 0 ? "indicator" : _type, _isGuestCompanyStock = param.isGuestCompanyStock, isGuestCompanyStock = _isGuestCompanyStock === void 0 ? false : _isGuestCompanyStock, onClick = param.onClick;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isVisible = ref[0], setVisible = ref[1];
    var onCloseModal = function() {
        return setVisible(false);
    };
    var onOpenModal = function() {
        return setVisible(true);
    };
    var onClickBar = function(event) {
        // eslint-disable-next-line chai-friendly/no-unused-expressions
        isGuestCompanyStock ? onClick(event) : onOpenModal();
    };
    var renderTag = function(isNotationBadges) {
        return(// @ts-expect-error
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .NotationTag */ .GU, {
            type: type,
            isSmall: true,
            isNotationBadges: isNotationBadges,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                alt: "indikator notasi khusus",
                src: INDICATOR_ICON_URL
            })
        }));
    };
    var notationList = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return notation.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.notation_code;
        });
    }, [
        notation
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .NotationBar */ .H_, {
                align: "center",
                justify: "space-between",
                px: "18px",
                onClick: onClickBar,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        align: "center",
                        justify: "flex-start",
                        children: [
                            renderTag(true),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                as: "span",
                                weight: "600",
                                size: "11px",
                                height: "13.4px",
                                ml: "8px",
                                family: "bold",
                                mr: "6px",
                                children: "Perusahaan memiliki Notasi Khusus"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .NotationBadgeContainer */ .Nj, {
                                children: notationList.map(function(code, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            code,
                                            index < notationList.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                src: "/icon/notsus-badge-dot.svg"
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        align: "center",
                        justify: "flex-end",
                        style: {
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .IconArrow */ .CC, {
                            as: "span"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .ModalIndicatorBar */ .Qu, {
                visible: isVisible,
                onCancel: onCloseModal,
                title: null,
                centered: true,
                width: "520px",
                bodyStyle: {
                    padding: "16px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Content__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    symbol: symbol,
                    uma: uma,
                    notation: notation,
                    name: name,
                    notationTag: renderTag(true),
                    isFullsize: true
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (IndicatorBar);


/***/ }),

/***/ 63631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10808);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var _deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48308);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var global_TradingModal_hooks_useIsUserSyariah__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66940);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69836);







var PopoverNotation = function(param) {
    var company = param.company;
    var dayTradeInfo = company.day_trade_info, tradingLimitInfo = company.trading_limit_info;
    var ref = dayTradeInfo || {}, multiplier = ref.multiplier, isShowMultiplier = ref.is_show_multiplier;
    var isUserSyariah = (0,global_TradingModal_hooks_useIsUserSyariah__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var showMultiplier = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return [
            parseInt(multiplier, 10) > 1,
            isShowMultiplier,
            !isUserSyariah
        ].every(Boolean);
    }, [
        multiplier,
        isShowMultiplier,
        isUserSyariah
    ]);
    var showTradingLimit = tradingLimitInfo === null || tradingLimitInfo === void 0 ? void 0 : tradingLimitInfo.is_trading_limit;
    if (!showMultiplier && !showTradingLimit) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .PopoverBadgeContainer */ .LA, {
            children: [
                showMultiplier && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                            style: {
                                marginBottom: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    weight: "bold",
                                    children: "Day Trade"
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .MultiplierChip */ .L$, {
                                    className: "multiplier-chip",
                                    style: {
                                        marginLeft: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            src: "/images/day-trade/lightning-filled-company.svg",
                                            alt: "",
                                            height: "10",
                                            width: "10"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                            size: "12px",
                                            color: "#8277F8",
                                            weight: "bold",
                                            children: "".concat(multiplier, "x")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            height: "19px",
                            children: [
                                "Saham ini bisa dibeli dengan Day Trade dengan nilai hingga",
                                " ",
                                multiplier,
                                "x Trading Balance kamu."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                    ]
                }),
                showTradingLimit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                            style: {
                                marginBottom: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                    weight: "bold",
                                    children: "Trading Limit"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .TradingLimitBadge */ .o7, {
                                    style: {
                                        marginLeft: 4
                                    },
                                    children: "TL"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            height: "19px",
                            children: [
                                "Saham ini bisa dibeli dengan Trading Limit dan dapat dijadikan jaminan dengan haircut ",
                                tradingLimitInfo === null || tradingLimitInfo === void 0 ? void 0 : tradingLimitInfo.haircut_percentage,
                                "."
                            ]
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .NotationPopoverContainer */ .MC, {
            children: [
                showMultiplier && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .MultiplierContainer */ .cF, {
                    style: {
                        cursor: "default"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .MultiplierChip */ .L$, {
                        className: "multiplier-chip",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                src: "/images/day-trade/lightning-filled-company.svg",
                                alt: "",
                                height: "10",
                                width: "10"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                size: "12px",
                                color: "#8277F8",
                                weight: "bold",
                                children: "".concat(multiplier, "x")
                            })
                        ]
                    })
                }),
                showTradingLimit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .TradingLimitBadge */ .o7, {
                    style: {
                        cursor: "default",
                        marginLeft: !showMultiplier ? 8 : 0
                    },
                    children: "TL"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PopoverNotation);


/***/ }),

/***/ 66940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useIsUserSyariah; }
});

// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
;// CONCATENATED MODULE: ./src/global/Securities/types/api/auth.ts
var AccountTypeEnum;
(function(AccountTypeEnum) {
    AccountTypeEnum["EQUITY"] = "ACCOUNT_TYPE_EQUITY";
    AccountTypeEnum["SYARIAH"] = "ACCOUNT_TYPE_SYARIAH";
    AccountTypeEnum["BOND"] = "ACCOUNT_TYPE_BOND";
    AccountTypeEnum["DAY_TRADING"] = "ACCOUNT_TYPE_DAY_TRADING";
})(AccountTypeEnum || (AccountTypeEnum = {}));

;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts


var useIsSyariahUser = function() {
    var accountType = securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().accountType;
    return accountType === AccountTypeEnum.SYARIAH;
};
/* harmony default export */ var useIsUserSyariah = (useIsSyariahUser);


/***/ }),

/***/ 56198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21671);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19225);




//  Utils

function useProtectedRoute() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isLoaded = ref[0], setIsLoaded = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .selectors */ .wl).isLoggedIn;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var token = utils_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getToken */ .Z.getToken();
        if (!isLoggedIn && !(token === null || token === void 0 ? void 0 : (ref = token.accessToken) === null || ref === void 0 ? void 0 : ref.token)) {
            // @ts-ignore
            dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_3__/* .effects.logout */ .Sz.logout());
            router.push("/login");
            return;
        }
        setIsLoaded(true);
    }, [
        dispatch,
        isLoggedIn,
        router
    ]);
    return {
        isLoaded: isLoaded
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useProtectedRoute);


/***/ }),

/***/ 91601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ renderTags; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/Notation/index.tsx
var Notation = __webpack_require__(15068);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionTag.tsx
var CorpActionTag = __webpack_require__(66988);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Badges/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: 0.8px solid #f14747;\n  border-radius: 2px;\n  color: ",
        ";\n  display: inline-block;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: normal;\n  padding: 0px 5px;\n  position: relative;\n  vertical-align: middle;\n\n  > span {\n    font-style: normal;\n    font-family: var(--bold-font);\n    line-height: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f0777c04-0"
})(_templateObject(), color/* default.light */.Z.light, color/* default.sunsetOrange */.Z.sunsetOrange);

;// CONCATENATED MODULE: ./src/global/Badges/index.tsx


var STATUS_LIST = {
    SUSPENDED: [
        1,
        "STATUS_SUSPENDED"
    ],
    DELISTED: [
        2,
        "STATUS_DELISTED"
    ]
};
function Badges_Badge(param) {
    var status = param.status;
    var isDelisted = STATUS_LIST.DELISTED.includes(status);
    var isSuspended = STATUS_LIST.SUSPENDED.includes(status);
    var renderBadge = function(companyStatus) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: companyStatus
            })
        });
    };
    if (isDelisted) {
        return renderBadge("Delisted");
    }
    if (isSuspended) {
        return renderBadge("Suspended");
    }
    return null;
}
/* harmony default export */ var Badges = (Badges_Badge);

;// CONCATENATED MODULE: ./src/utils/tags.tsx
/* eslint-disable no-undef */ 




var compareValue = function(value, otherValue) {
    return !!value || !!otherValue;
};
/**
 * Render tags notation and corp action
 */ var renderTags = function(company) {
    var showPopover = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, placement = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "top", customContainerStyle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        marginLeft: 4,
        gap: 4
    };
    var symbol = company.symbol, symbol_2 = company.symbol_2, _notation = company.notation, notation = _notation === void 0 ? [] : _notation, _corp_action = company.corp_action, corp_action = _corp_action === void 0 ? {} : _corp_action, uma = company.uma, companyName = company.name, _withNotation = company.withNotation, withNotation = _withNotation === void 0 ? 0 : _withNotation, _withUMA = company.withUMA, withUMA = _withUMA === void 0 ? 0 : _withUMA, _withCorpAction = company.withCorpAction, withCorpAction = _withCorpAction === void 0 ? 0 : _withCorpAction, _status = company.status, status = _status === void 0 ? 0 : _status;
    var companySymbol = symbol || symbol_2;
    var showNotation = compareValue((notation === null || notation === void 0 ? void 0 : notation.length) > 0, withNotation);
    var showCorpAction = compareValue(corp_action === null || corp_action === void 0 ? void 0 : corp_action.active, withCorpAction);
    var showUma = compareValue(uma, withUMA);
    var showBadge = status !== 0;
    if (!showBadge && !showCorpAction && !showNotation && !showUma) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        style: customContainerStyle,
        children: [
            showNotation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                symbol: companySymbol,
                name: companyName,
                notation: notation,
                uma: false,
                isPopover: showPopover,
                isNotationBadges: true,
                placement: placement
            }),
            showCorpAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(CorpActionTag/* default */.Z, {
                corpAction: company.corp_action,
                isCorpActionBadges: true
            }),
            showBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badges, {
                status: status
            }),
            showUma && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                symbol: companySymbol,
                name: companyName,
                notation: notation,
                uma: showUma,
                isNotationBadges: true,
                type: "uma",
                placement: placement,
                isPopover: false
            })
        ]
    });
};
// eslint-disable-next-line import/prefer-default-export



/***/ })

}]);